require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./epfl-lausanne-0-4-0.json") })
        }
      }, "path---epfl-lausanne-0-4-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---epfl-lausanne-0-4-0!./.cache/json/epfl-lausanne-0-4-0.json
// module id = 415
// module chunks = 231608221292675